import React, { useEffect, useState } from "react";
import { Helmet } from "react-helmet";
import { motion } from "framer-motion";
import axios from "axios";
import "../biografie/biografie.scss"

const Biografie = () => {

    const [data, setPosts] = useState([]);
    const [isLoading, setLoading] = useState(true);

    useEffect(() => {
        const fetchAllPosts = async () => {
            try {
                const res = await axios.get("https://api.augschoell.com/wp-json/wp/v2/pages/2/")
                setPosts(res.data);
                setLoading(false);
            } catch (err) {
                console.log(err);
            }
        }
        fetchAllPosts()
    }, [])

    return (
        <div className="biografie">
            <Helmet>
                <title>Biografie | Jakob Augschöll</title>
            </Helmet>
            <div className="container">
                {
                    isLoading
                        ? <div className="loading" /> :
                        <div>
                            <motion.h2
                                initial={{ opacity: 0, y: 10 }}
                                whileInView={{ opacity: 1, y: 0 }}
                                transition={{ duration: 0.5, ease: "easeOut" }}
                            >
                                {data.title.rendered}
                            </motion.h2>
                            <motion.div
                                className="wp-content" dangerouslySetInnerHTML={{ __html: data.content.rendered }}
                                initial={{ opacity: 0, y: 10 }}
                                whileInView={{ opacity: 1, y: 0 }}
                                transition={{ duration: 0.5, ease: "easeOut", delay: 0.5 }}
                            />
                        </div>
                }
            </div>
        </div>
    )
};

export default Biografie